export default {
	data(){
		return {
			tableGBoptions: { 
				options: {editar: 'Editar Servicio', inactivar: 'Inactivar Servicio'},
				modals: []
			},

			tableGBSearch: ['multiple_servicios/name'],
			
			tableGBItems: [				
				{
					thead: { th: 'Servicio', sort: null, sortTable: 'multiple_servicios/name'},
					tbody: { td: ['multiple_servicios/name'],}
				},
				{
					thead: { th: 'Afiliacion', },
					tbody: { td: ['multiple_servicios/afiliacion'],}
				},
				{
					thead: { th: 'Valor', },
					tbody: { td: ['multiple_servicios/valor'],}
				},
			]			
		}
	},
}